<template>
  <div class="page-container">
    <div class="query-title">货权转移客户设置</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
        <template #button>
            <table-button name="export" tip="新增" @click="dialogVisible = true" />
            <table-button name="export" tip="删除" @click="deleteTransferCustomerSetting" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
          </vxe-grid>
        </Table-filter>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog
      title="新增货权转移客户设置"
      :visible.sync="dialogVisible"
      width="600px"
      :append-to-body="true"
    >
      <div class="dialog-content">
        <el-form :model="form" label-width="150px" size="small">
          <el-form-item label="转出客户编码" required>
            <wly-input
              v-model="form.transferCustomerCode"
              input-type="customer"
              @enter="handleFormEnter(...arguments, 'transfer')"
              @handleSuffixClick="showTransferDialog = true"
            />
          </el-form-item>
          <el-form-item label="转出客户名称">
            <el-input v-model="form.transferCustomerName" readonly />
          </el-form-item>
          <el-form-item label="转入客户编码" required>
            <wly-input
              v-model="form.receiveCustomerCode"
              input-type="customer"
              @enter="handleFormEnter(...arguments, 'receive')"
              @handleSuffixClick="showReceiveDialog = true"
            />
          </el-form-item>
          <el-form-item label="转入客户名称">
            <el-input v-model="form.receiveCustomerName" readonly />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
    <!-- 转出客户选择弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="showTransferDialog" title="转出客户选择" width="70%">
      <template v-if="showTransferDialog">
        <client-select ref="transferClientSelect" :isRadio="true" />
      </template>
      <div slot="footer">
        <el-button size="small" type="default" @click="showTransferDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleTransferClientSelect">确定</el-button>
      </div>
    </el-dialog>
    <!-- 转入客户选择弹窗 -->
    <el-dialog v-dialogDrag :visible.sync="showReceiveDialog" title="转入客户选择" width="70%">
      <template v-if="showReceiveDialog">
        <client-select ref="receiveClientSelect" :isRadio="true" />
      </template>
      <div slot="footer">
        <el-button size="small" type="default" @click="showReceiveDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleReceiveClientSelect">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findReceiveCustomersByTransferCustomer, deleteTransferCustomerSetting, addTransferCustomerSetting, findTransferCustomerSettingByPage } from '@/api/applyForGoods'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/transferCustomerSetting'
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
export default {
  mixins: [tableMixins],
  components: { ClientSelect },
  data() {
    return {
      showBtn: '',
      conditions: {
        templateCode: '',
        batchNumber: ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
        ],
        columns: [
          { type: 'checkbox', title: '', width: 50, field: 'checkbox' },
          {
            title: '转出客户编码',
            field: 'transferCustomerCode'
          },
          {
            title: '转出客户名称',
            field: 'transferCustomerName'
          },
          {
            title: '转入客户编码',
            field: 'receiveCustomerCode'
          },
          {
            title: '转入客户名称',
            field: 'receiveCustomerName'
          }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      dialogVisible: false,
      showTransferDialog: false,
      showReceiveDialog: false,
      form: {
        transferCustomerCode: '',
        transferCustomerName: '',
        receiveCustomerCode: '',
        receiveCustomerName: ''
      },
      errorList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    // 手动设置查询字段，从 pageConfig 中提取有 type 的字段
    const searchField = {}
    Object.keys(pageConfig).forEach(key => {
      if (pageConfig[key].type) {
        searchField[key] = pageConfig[key]
      }
    })
    this.searchField = Object.keys(pageSearch).length > 0 ? { ...pageSearch, ...searchField } : searchField
  },
  methods: {
    // 表单客户输入框回车
    async handleFormEnter(e, type, data, field) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : Message.error(type.message)
        return
      }
      if (!data) return
      if (field === 'transfer') {
        this.form.transferCustomerCode = data.customerCode
        this.form.transferCustomerName = data.customerName
      } else {
        this.form.receiveCustomerCode = data.customerCode
        this.form.receiveCustomerName = data.customerName
      }
    },
    // 转出客户选择确定
    async handleTransferClientSelect() {
      const data = await this.$refs.transferClientSelect.submitForm()
      if (!data) {
        return Message.warning('请选择转出客户')
      }
      this.form.transferCustomerCode = data.customerCode
      this.form.transferCustomerName = data.customerName
      this.showTransferDialog = false
    },
    // 转入客户选择确定
    async handleReceiveClientSelect() {
      const data = await this.$refs.receiveClientSelect.submitForm()
      if (!data) {
        return Message.warning('请选择转入客户')
      }
      this.form.receiveCustomerCode = data.customerCode
      this.form.receiveCustomerName = data.customerName
      this.showReceiveDialog = false
    },
    // 新增
    async submitHandle() {
      if (!this.form.transferCustomerCode) {
        return Message.warning('请选择转出客户')
      }
      if (!this.form.receiveCustomerCode) {
        return Message.warning('请选择转入客户')
      }
      
      try {
        await addTransferCustomerSetting({
          transferCustomerCode: this.form.transferCustomerCode,
          transferCustomerName: this.form.transferCustomerName,
          receiveCustomerCode: this.form.receiveCustomerCode,
          receiveCustomerName: this.form.receiveCustomerName
        })
        this.dialogVisible = false
        Message.success('添加成功')
        this.form = {
          transferCustomerCode: '',
          transferCustomerName: '',
          receiveCustomerCode: '',
          receiveCustomerName: ''
        }
        this.queryData()
      } catch (error) {
        Message.warning(error.message || '添加失败')
      }
    },
    // 删除
    async deleteTransferCustomerSetting() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      if (checkData.length === 0) {
        return Message.warning('请选择要删除的数据')
      }
      
      // 验证参数
      for (const item of checkData) {
        if (!item.transferCustomerCode || !item.receiveCustomerCode) {
          return Message.warning('选中的数据缺少必要参数，无法删除')
        }
      }
      
      const promises = checkData.map(item => {
        return deleteTransferCustomerSetting({
          transferCustomerCode: item.transferCustomerCode,
          receiveCustomerCode: item.receiveCustomerCode
        })
      })
      
      try {
        await Promise.all(promises)
        Message.success('删除成功')
        this.queryData()
      } catch (error) {
        Message.warning(error.message || '删除失败')
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
      }
      
      this.loading = true
      try {
        // 如果有转出客户编码，使用查询转入客户列表接口（关联查询客户其他信息）
        if (params.transferCustomerCode && params.transferCustomerCode.length > 0) {
          const transferCustomerCode = params.transferCustomerCode[0].value
          const queryParams = {
            ...params,
            transferCustomerCode: transferCustomerCode
          }
          const { data: { Rows, Total }, calculation, field } = await findReceiveCustomersByTransferCustomer(queryParams)
          if (Rows.length === 0 && Total) {
            this.queryData(1, ranges)
            return
          }
          this.pagination.totalCount = Total - 0
          this.calculation = this.filtercalculation(calculation, 'xTable', true)
          // 更新计算值
          this.updateCount()
          if (this.showHeader) {
            this.gridOptions.data = this.tableCountData.concat(Rows)
          } else {
            this.gridOptions.data = Rows.concat(this.tableCountData)
          }
          this.allOptions = this.filterAllOptions(field, 'xTable', true)
          this.setFilter()
        } else {
          // 没有转出客户编码，使用分页查询接口
          const { data: { Rows, Total }, calculation, field } = await findTransferCustomerSettingByPage(params)
          if (Rows.length === 0 && Total) {
            this.queryData(1, ranges)
            return
          }
          this.pagination.totalCount = Total - 0
          this.calculation = this.filtercalculation(calculation, 'xTable', true)
          // 更新计算值
          this.updateCount()
          if (this.showHeader) {
            this.gridOptions.data = this.tableCountData.concat(Rows)
          } else {
            this.gridOptions.data = Rows.concat(this.tableCountData)
          }
          this.allOptions = this.filterAllOptions(field, 'xTable', true)
          this.setFilter()
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  .el-dropdown{
    font-size: 12px;
    padding-left: 10px;
    color: #333;
  }
  /deep/ .el-checkbox{
    .el-checkbox__input {
      display: none
    }
  }
  .dialog-content {
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/transferCustomerSetting.vue